import { LocationType, citySearchHistory } from 'shared';
import type { MappedCity } from 'shared';

import type { hotOffersTypes } from '@/entities/hot-offers';

const searchHistory = citySearchHistory.model.useCitySearchHistory('free-avia');

const buildMappedCity = (
  city: {
    code: string;
    name?: string;
    name_ru: string;
    name_en: string;
    name_kk: string;
  },
  country: {
    code: string;
    iso_code: string;
    name?: string;
    name_ru: string;
    name_en: string;
    name_kk: string;
  },
): MappedCity => ({
  type: LocationType.CITY,
  code: city.code,
  name: city.name ?? city.name_ru,
  name_ru: city.name_ru,
  name_en: city.name_en,
  name_kk: city.name_kk,
  country: {
    type: LocationType.COUNTRY,
    code: country.code,
    name: country.name ?? country.name_ru,
    name_ru: country.name_ru,
    name_en: country.name_en,
    name_kk: country.name_kk,
  },
});

export const saveCitiesFromOffer = (offer: hotOffersTypes.MappedHotOffer) => {
  const dep = buildMappedCity(offer.origin.city, offer.origin.country);
  const arr = buildMappedCity(
    offer.destination.city,
    offer.destination.country,
  );
  searchHistory.saveCity(dep);
  searchHistory.saveCity(arr);
};
